import { Can } from '@/components/common/Can';
import type { PermissionCode } from '@/constants/permissions';
import { RowActionButton } from './RowActionButton';
import { RowActionGroup } from './RowActionGroup';

interface RowEditDeleteButtonsProps<TItem> {
  item: TItem;
  itemName: string;
  onEdit?: ((item: TItem) => void) | undefined;
  onDelete?: ((item: TItem) => void) | undefined;

  editRequires?: PermissionCode | undefined;
  deleteRequires?: PermissionCode | undefined;
}

export function RowEditDeleteButtons<TItem>({
  item,
  itemName,
  onEdit,
  onDelete,
  editRequires,
  deleteRequires,
}: RowEditDeleteButtonsProps<TItem>) {
  return (
    <RowActionGroup>
      {onEdit && (
        <Can code={editRequires}>
          <RowActionButton
            label="Edit"
            ariaLabel={`Edit ${itemName}`}
            onClick={() => onEdit(item)}
          />
        </Can>
      )}
      {onDelete && (
        <Can code={deleteRequires}>
          <RowActionButton
            label="Delete"
            ariaLabel={`Delete ${itemName}`}
            onClick={() => onDelete(item)}
            tone="destructive"
          />
        </Can>
      )}
    </RowActionGroup>
  );
}
